<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <div class="recuadro-widget" style="width: 100%">
      <span class="recuadro-widget-icon bg-green"><i class="fa fa-check-circle fa-lg"></i></span>

      <div class="recuadro-widget-content">
        <span class="recuadro-widget-number">{{contador}}</span>
        <span class="recuadro-widget-text">{{'WIDGETS.LBL_WIDGETSOLICITUDES' | translate }}</span>
        <div class="col-12 md:col-12 lg:col-12" style="display: flex;">
          <button style="width: 190%; font-size: 12px;" icon="fa fa-arrow-up" class="p-button p-widget p-state-default p-corner-all p-button-text-only text-center"  label="{{ 'BTN_ACTUALIZAR' | translate}}"
                  type="button" (click)="cargarContador()"
                  pButton ></button>
          <button style="width: 100%; margin-left: 10px; font-size: 12px; background-color: #F04505;" icon="fa fa-plus" class="p-button p-widget p-state-default p-corner-all p-button-text-only excepcion-button" label="{{'WIDGETS.BTN_VERMAS' | translate }}"
                  type="button" (click)="cargarSolicitudes()"
                  pButton></button>
          <div class="col-12 text-center" *ngIf="loading">
            <i class="fa fa-refresh fa-spin"></i>  <span><strong>{{'LBL_PROCESANDO' | translate }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="{{ 'WIDGETS.LBL_WIDGETSOLICITUDES' | translate }}" [(visible)]="showModalSolicitudes"
          *ngIf="showModalSolicitudes"
          [positionTop]="60" [contentStyle]="{'width':'1200px', 'overflow-y': 'auto'}" responsive="true" modal="true">
  <div class="grid">
    <div class="lg:col-12">
      <p-table [columns]="columnas" [loading]="cargandoTabla"
               [rows]="10" [value]="listSolicitudes" [paginator]="true"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.id}}</td>
            <td>{{row.fechaSolicitud | date :'dd/MM/yyyy HH:mm'}}</td>
            <td>{{row.numeroDocumento}}</td>
            <td>{{row.nombres}}</td>
            <td>{{row.estadoActual}}</td>
            <td>{{row.fechaAnulacion | date :'dd/MM/yyyy HH:mm'}}</td>
            <td>{{row.causaul}}</td>
            <td>{{row.observacion}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-check" data-toggle="tooltip"
                        title="{{'BTN_ACEPTAR' | translate}}"
                        pButton (click)="cambioEstado(row, true )"></button>
                <button type="button" class="p-button btn" icon="fa fa-ban" data-toggle="tooltip"
                        title="{{'BTN_DENEGAR' | translate}}"
                        pButton (click)="cambioEstado(row, false )"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>
